import React from 'react';
import ProgressIndicatorItem from './ProgressIndicatorItem';

function ProgressIndicator(props) {
  const steps = props.steps;

  function generateSteps() {
    return steps.map((step, index) => (
      <ProgressIndicatorItem
        status={step.status}
        title={step.title}
        first={step.first}
        last={step.last}
        key={index}
        data-test="progress-item"
      />
    ));
  }

  return (
    <div className="progress-bar-split" data-test="progress-bar">
      {generateSteps()}
    </div>
  );
}

export default ProgressIndicator;
